const d = (e) => import(/* webpackChunkName: "checkMetamask" */ './checkMetamask').then(async (module) => {
  return (
    await module.default()
  );
});

export default d;
